import styled from "styled-components";
import { pxToRem } from "../../../utils/pxToRem";

export const Form = styled.form`
  width: 100%;
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 32px 0;

  > :last-child {
    width: fit-content;
    margin: 0 auto;
    display: flex;
    gap: 0 32px;
  }
`;

export const FlexWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px 16px;

  @media (min-width: 640px) {
    flex-direction: row;
    > div {
      flex: 1;
    }
  }
`;

export const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px 16px;
  margin: 0 auto;
  width: 100%;
  max-width: 700px;

  > :nth-child(1) {
    grid-area: text;
  }

  > :nth-child(2) {
    grid-area: nome;
  }

  > :nth-child(3) {
    grid-area: telefone;
  }

  > :nth-child(4) {
    grid-area: concessionaria;
  }

  > :nth-child(5) {
    grid-area: button;
  }

  @media (min-width: 640px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-areas: "text text" "nome nome" "telefone concessionaria" "button button";
  }
`;

export const GridWrapper = styled.div`
  display: grid;

  grid-template-columns: repeat(2, 1fr);
  gap: ${pxToRem(32)} ${pxToRem(16)};
  grid-template-areas: "title title" "nome nome" "telefone cep" "rua rua" "numero complemento" "bairro bairro" "uf cidade";

  > :nth-child(1) {
    grid-area: title;
  }

  > :nth-child(2) {
    grid-area: nome;
  }

  > :nth-child(3) {
    grid-area: telefone;
  }

  > :nth-child(4) {
    grid-area: cep;
  }

  > :nth-child(5) {
    grid-area: rua;
  }

  > :nth-child(6) {
    grid-area: numero;
  }

  > :nth-child(7) {
    grid-area: complemento;
  }

  > :nth-child(8) {
    grid-area: bairro;
  }

  > :nth-child(9) {
    grid-area: uf;
  }

  > :nth-child(10) {
    grid-area: cidade;
  }

  @media (min-width: 640px) {
    grid-template-columns: repeat(6, 1fr);
    gap: ${pxToRem(32)} ${pxToRem(16)};
    grid-template-areas: "title title title title title title" "nome nome nome nome nome nome" "telefone telefone telefone cep cep cep" "rua rua rua rua rua rua" "numero numero numero complemento complemento complemento" "bairro bairro uf uf cidade cidade";
  }
`;

export const WrapperInfos = styled.div`
  margin-top: 42px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  width: 100%;
`;
